import React from 'react';
import { DialogTitle, DialogContent, DialogActions, Button, Typography, Box } from '@mui/material';
import { BlurDialog } from '../../utils';
import { LassoSampleAction } from '../../../services/LassoService';

interface LassoActionDialogProps {
  open: boolean;
  title: string;
  message: string;
  actions: LassoSampleAction[];
  onActionSelected: (action: LassoSampleAction) => void;
}

/**
 * A custom MUI Dialog component for lasso actions
 * Replaces alertFullScreen with better UX and more flexibility
 */
export const LassoActionDialog: React.FC<LassoActionDialogProps> = ({
  open,
  title,
  message,
  actions,
  onActionSelected,
}) => {
  const getButtonColor = (action: LassoSampleAction): 'primary' | 'secondary' | 'inherit' => {
    switch (action.name) {
      case 'Remove':
        return 'secondary';
      case 'Cancel':
        return 'inherit';
      default:
        return 'primary';
    }
  };

  const getButtonVariant = (action: LassoSampleAction): 'contained' | 'outlined' | 'text' => {
    if (action.name === 'Cancel') {
      return 'text';
    }

    return 'outlined';
  };

  return (
    <BlurDialog open={open} maxWidth="md" fullWidth disableEscapeKeyDown>
      <DialogTitle component="div">
        <Typography variant="h4" align="center">
          {title}
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Box sx={{ py: 2 }}>
          <Typography variant="h6" align="center" gutterBottom>
            {message}
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
        <Box display="flex" flexDirection="column" gap={2} flexWrap="wrap" justifyContent="center">
          {actions.map((action) => (
            <Box key={action.name} display="flex" flexDirection="row" justifyContent="space-between">
              <Button
                variant={getButtonVariant(action)}
                color={getButtonColor(action)}
                size="large"
                onClick={() => onActionSelected(action)}
                sx={{
                  minWidth: 120,
                  fontSize: '1rem',
                  paddingX: 3,
                  paddingY: 1.5,
                }}
              >
                {action.name}
              </Button>

              <Typography variant="body1" align="right" sx={{ alignSelf: 'center', marginLeft: 2, maxWidth: 300 }}>
                {action.description}
              </Typography>
            </Box>
          ))}
        </Box>
      </DialogActions>
    </BlurDialog>
  );
};

export default LassoActionDialog;
